import { Component, OnInit, Output, EventEmitter, OnDestroy, Input, AfterViewInit, ViewChild } from '@angular/core';
import { LoginStateService } from '../../services/login-state.service';
import { NotificationService } from '../../../general/services/notification.service';
import { ShopSettingsService } from '../../../general/services/shop-settings.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input()
  email: string;

  @Input()
  readOnlyEmail: boolean;

  @Input()
  showRememberMe = true;

  password: string;
  rememberMe: boolean;

  @Output()
  eventLoggedIn = new EventEmitter();

  @Output()
  eventResetPassword = new EventEmitter<string>();

  @Input()
  showBack: boolean;

  @Input()
  showRegistrationUrl: boolean;

  @Output()
  eventBack = new EventEmitter();

  @Output()
  eventRegister = new EventEmitter();

  @ViewChild('inputPassword', { static: true }) inputPassword: any;

  @ViewChild(NgForm, { static: true }) form: NgForm;

  constructor(
    private loginStateService: LoginStateService,
    private notificationService: NotificationService,
    private shopSettingsService: ShopSettingsService,
  ) {

  }

  ngAfterViewInit() {
    if (this.readOnlyEmail && this.inputPassword && this.inputPassword.focusInput) {
      this.inputPassword.focusInput();
    }
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.notificationService.hide(LoginComponent.name);
  }

  login(login: string, password: string, rememberMe: boolean) {
    this.notificationService.hide(LoginComponent.name);
    this.loginStateService.login(login, password, rememberMe).subscribe(
      data => {
        if (this.loginStateService.isLoggedIn) {

          this.eventLoggedIn.emit();
        } else {
          this.notificationService.show(LoginComponent.name, `Login failed!`);
        }
      },
      error => {
        this.notificationService.show(LoginComponent.name, error.message);
      },
    );
  }

  onResetPassword(email: string) {
    this.loginStateService.resetPassword(email).subscribe(
      (message: string) => {
        this.notificationService.show(LoginComponent.name, 'An email has been sent with credentials to reset your password');
      },
      (error: Error) => {
        this.notificationService.show(LoginComponent.name, 'An email has been sent with credentials to reset your password');
      },
    );
  }

  onEnterPressed() {
    if (!this.isFormValid) {
      return;
    }

    this.login(this.email, this.password, this.rememberMe);
  }

  onBack() {
    this.eventBack.emit();
  }

  onRegister() {
    this.eventRegister.emit();
  }

  get isFormValid() {
    return this.form?.valid;
  }

  get canResetPassword(): boolean {
    return this.shopSettingsService.shopSettings.canResetPassword;
  }
}
